import { Title } from '@/components/commons/typography/Title'
import { cssClass } from '@/shared/utils'

import { AnalyticsWithoutSocialConnected } from '../provisional/no-social-connected'

export const ProfileOverviewAnalyticsEmptyState = () => {
  return (
    <div className={cssClass(['px-20 px-0--tablet'])}>
      <Title sizeClass="text-16 text-20--tablet mb-20">Analytics</Title>
      <AnalyticsWithoutSocialConnected />
    </div>
  )
}
